import { InfoIconTemplate, InfoIconTemplateProps } from "./template";

export type InfoIconProps = InfoIconTemplateProps;

export const InfoIcon = (props: InfoIconProps): JSX.Element => {
  return <InfoIconTemplate {...props} />;
}; 